import React, {useState} from "react";
import "./ContactUsDetails.css";

const ContactUsDetails = React.memo(props => {
    let engContactForm = props.lang==='en';
    
     return (
        <React.Fragment>
            {/* <div className="container1"> */}
                <div className="mainHowToGetContainer">
                    <div className={engContactForm?"detailsHowToGetContainer detailsHowToGetContainerEN" : "detailsHowToGetContainer"}>
                        <h3>{engContactForm?"How to arrive": "איך להגיע"}</h3>
                        <div className="phoneMailAddressContainer">
                            <span>{props.items.LinkTitle},</span>
                            <span dangerouslySetInnerHTML={{__html: props.items.ModFooterAddress}}></span>
                            <span>{engContactForm?"Tel:" : "טלפונים:"} </span>
                            <span><a href={"tel:"+props.items.MODPhone1} className="disablePhoneBigScreen" title={props.items.MODPhone1}>{props.items.MODPhone1}, </a></span>
                            <span><a  href={"tel:"+props.items.MODPhone2} className="disablePhoneBigScreen" title={props.items.MODPhone2}>{props.items.MODPhone2}</a><br></br></span>
                            <span>{engContactForm?"Mail:":'דוא"ל:'} </span>
                            <a href={"mailto:"+props.items.MODSiteMail} title={props.items.MODSiteMail}>{props.items.MODSiteMail}</a>    
                        </div>   
                        <br></br>
                        <div className="daysAndHoursDiv">
                            <span>{engContactForm? "Visit Hours:": "ימים ושעות הביקור:"}<br></br></span>
                            <span dangerouslySetInnerHTML={{__html: props.items.ModOpeningHours}}></span>
                        </div>
                        <div className="toursOrganizationDiv">
                            <span>{engContactForm? "Coordinating Tours:": "לתיאום סיורים:"}<br></br></span>
                            <span><a href={"tel:"+props.items.MODTourPhone} className="disablePhoneBigScreen" title={props.items.MODTourPhone}>{props.items.MODTourPhone}</a></span>
                        </div>
                        <div className="wazeButtonDiv">
                            <a href={props.items.MODNav} className="wazeButton">
                                    <span>{engContactForm?"Navigation":"לניווט"}</span>
                                    <i className="fab fa-waze"></i>
                            </a>
                        </div>
                        </div>
                    <div className="mapHowToGetContainer">
                        <iframe className="googleMapFrameArea" src={props.items.MODGoogleMap}></iframe>
                        {/* <iframe className="googleMapFrameArea" src={"/_layouts/15/images/sites/Museums/ContactUs/map111.png"}></iframe> */}
                    </div>
                </div>
            {/* </div> */}
        </React.Fragment>
    );
});
export default ContactUsDetails;